import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useEventHandler } from '@snack-uikit/utils';
import { BUTTON_SIZE_MAP } from '../constants';
import { ButtonClearValue } from '../helperComponents';
/**
 * Позволяет использовать кнопку сброса значения
 * @function hook
 */
export function useClearButton({ clearButtonRef, showClearButton, size, onClear }) {
    const clearEventHandler = useEventHandler(onClear);
    return useMemo(() => ({
        id: 'clear',
        active: true,
        ref: clearButtonRef,
        show: showClearButton,
        render: props => {
            const handleClear = event => {
                props.onClick(event);
                clearEventHandler(event);
            };
            return _jsx(ButtonClearValue, Object.assign({}, props, { size: BUTTON_SIZE_MAP[size], onClick: handleClear }));
        },
    }), [clearButtonRef, clearEventHandler, showClearButton, size]);
}
